import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-31bbd01e")

_pushScopeId("data-v-31bbd01e")
const _hoisted_1 = { class: "grid-toolbar-buttons buttons is-right" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_edit_item_cell = _resolveComponent("edit-item-cell")
  const _component_grid_toolbar = _resolveComponent("grid-toolbar")
  const _component_Grid = _resolveComponent("Grid")

  return (_openBlock(), _createBlock(_component_Grid, {
    ref: "grid",
    "data-items": _ctx.pageItems,
    columns: _ctx.gridColumns,
    skip: _ctx.skip,
    take: _ctx.take,
    total: _ctx.total,
    pageable: _ctx.pageable,
    "page-size": _ctx.pageSize,
    sort: _ctx.sort,
    filter: _ctx.filter,
    sortable: true,
    resizable: true,
    filterable: true,
    "edit-field": 'inEdit',
    onFilterchange: _ctx.filterChange,
    onPagechange: _ctx.pageChangeHandler,
    onItemchange: _ctx.onItemChange,
    onSortchange: _ctx.sortChange
  }, {
    editItemTemplate: _withId(({ props }) => [
      _createVNode(_component_edit_item_cell, {
        "data-item": props.dataItem,
        onEdit: _ctx.onEditStart,
        onSave: _ctx.onSave,
        onCancel: _ctx.onCancel
      }, null, 8, ["data-item", "onEdit", "onSave", "onCancel"])
    ]),
    default: _withId(() => [
      (_ctx.isToolBarRequired)
        ? (_openBlock(), _createBlock(_component_grid_toolbar, { key: 0 }, {
            default: _withId(() => [
              _createVNode("div", _hoisted_1, [
                _renderSlot(_ctx.$slots, "toolbar-button"),
                (!_ctx.isReadOnly)
                  ? (_openBlock(), _createBlock("button", {
                      key: 0,
                      title: "Add new",
                      type: "button",
                      class: "button is-primary",
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onAddNew && _ctx.onAddNew(...args)))
                    }, " Add new "))
                  : _createCommentVNode("", true),
                (_ctx.isGridInEditMode)
                  ? (_openBlock(), _createBlock("button", {
                      key: 1,
                      title: "Cancel current changes",
                      type: "button",
                      class: "button is-danger",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onCancel && _ctx.onCancel(...args)))
                    }, " Cancel current changes "))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 3
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["data-items", "columns", "skip", "take", "total", "pageable", "page-size", "sort", "filter", "onFilterchange", "onPagechange", "onItemchange", "onSortchange"]))
})